import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Typography,
  Spin,
  Collapse,
  Slider,
  InputNumber,
  Select,
  Checkbox,
  Drawer,
  Space,
  Button,
  Tag,
} from "antd";
import {
  usePropertiesState,
  usePropertiesDispatch,
} from "../contexts/properties";
import { actions } from "../contexts/properties/actions";
import ListingCard from "../components/ListingCard";
import {
  sortByMinPrice,
  sortByMaxPrice,
  sortByMinSqFt,
  sortByMaxSqFt,
  zipcodeValidation,
  filterByState,
  filterMinPrice,
  filterMaxPrice,
  filterMinBedrooms,
  filterMinBathrooms,
  filterMinSqFt,
  filterHasYard,
  filterHasAC,
  filterParking,
  filterPool,
} from "../helpers/utils";
import { States } from "../helpers/constants";
import { FilterFilled } from "@ant-design/icons";
import NewsletterContact from "../components/NewsletterContact";

const { Panel } = Collapse;

function Home() {
  const MAX_PRICE_VALUE = 10000000;
  const [propertiesFiltered, setPropertiesFiltered] = useState<any>();
  const [inputZipcodeValue, setInputZipcodeValue] = useState();
  const [inputStateValue, setInputStateValue] = useState();

  const [inputMinPriceValue, setInputMinPriceValue] = useState(0);
  const [inputMaxPriceValue, setInputMaxPriceValue] = useState(MAX_PRICE_VALUE);
  const [inputMinBathrooms, setInputMinBathrooms] = useState(0);
  const [inputMinBedrooms, setInputMinBedrooms] = useState(0);
  const [inputMinSqFt, setInputMinSqFt] = useState(0);

  const [inputSortBy, setInputSortBy] = useState();

  const [inputHasYardChecked, setInputHasYardChecked] = useState(false);
  const [inputHasACChecked, setInputHasAChecked] = useState(false);
  const [inputHasPoolChecked, setInputHasPoolChecked] = useState(false);
  const [inputHasParkingChecked, setInputHasParkingChecked] = useState(false);

  const { properties, isPropertiesLoading } = usePropertiesState();
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const openDrawer = () => {
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const dispatch = usePropertiesDispatch();

  //Annoyign filters
  const bigFilter = () => {
    let propertiesHaveAllFiltered = properties;
    if (inputZipcodeValue) {
      propertiesHaveAllFiltered = zipcodeValidation(
        propertiesHaveAllFiltered,
        inputZipcodeValue
      );
    }
    if (inputStateValue) {
      propertiesHaveAllFiltered = filterByState(
        propertiesHaveAllFiltered,
        inputStateValue
      );
    }
    if (inputMinPriceValue) {
      propertiesHaveAllFiltered = filterMinPrice(
        propertiesHaveAllFiltered,
        inputMinPriceValue
      );
    }
    if (inputMaxPriceValue) {
      propertiesHaveAllFiltered = filterMaxPrice(
        propertiesHaveAllFiltered,
        inputMaxPriceValue
      );
    }
    if (inputMinBathrooms) {
      propertiesHaveAllFiltered = filterMinBathrooms(
        propertiesHaveAllFiltered,
        inputMinBathrooms
      );
    }
    if (inputMinBedrooms) {
      propertiesHaveAllFiltered = filterMinBedrooms(
        propertiesHaveAllFiltered,
        inputMinBedrooms
      );
    }
    if (inputMinSqFt) {
      propertiesHaveAllFiltered = filterMinSqFt(
        propertiesHaveAllFiltered,
        inputMinSqFt
      );
    }

    if (inputHasYardChecked) {
      propertiesHaveAllFiltered = filterHasYard(propertiesHaveAllFiltered);
    }
    if (inputHasACChecked) {
      propertiesHaveAllFiltered = filterHasAC(propertiesHaveAllFiltered);
    }
    if (inputHasPoolChecked) {
      propertiesHaveAllFiltered = filterPool(propertiesHaveAllFiltered);
    }
    if (inputHasParkingChecked) {
      propertiesHaveAllFiltered = filterParking(propertiesHaveAllFiltered);
    }

    if (inputSortBy === "minPrice") {
      sortByMinPrice(propertiesHaveAllFiltered);
    }
    if (inputSortBy === "maxPrice") {
      sortByMaxPrice(propertiesHaveAllFiltered);
    }
    if (inputSortBy === "minSqFt") {
      sortByMinSqFt(propertiesHaveAllFiltered);
    }
    if (inputSortBy === "maxSqFt") {
      sortByMaxSqFt(propertiesHaveAllFiltered);
    }
    if (inputSortBy === "Select") {
      setInputSortBy(undefined);
    }

    return propertiesHaveAllFiltered;
  };

  const onChangeZipcodeValidation = (newValue: any) => {
    setInputZipcodeValue(newValue);
  };
  const onChangeState = (newValue: any) => {
    setInputStateValue(newValue);
  };

  const onChangeMinPrice = (newValue: any) => {
    setInputMinPriceValue(newValue);
  };
  const onChangeMaxPrice = (newValue: any) => {
    setInputMaxPriceValue(newValue);
  };
  const onChangeMinBathrooms = (newValue: any) => {
    setInputMinBathrooms(newValue);
  };
  const onChangeMinBedrooms = (newValue: any) => {
    setInputMinBedrooms(newValue);
  };
  const onChangeMinSqFt = (newValue: any) => {
    setInputMinSqFt(newValue);
  };
  const handleChangeSortBy = (value: any) => {
    setInputSortBy(value);
  };
  const onChangeYard = (value: any) => {
    setInputHasYardChecked(value.target.checked);
  };
  const onChangeAC = (value: any) => {
    setInputHasAChecked(value.target.checked);
  };
  const onChangePool = (value: any) => {
    setInputHasPoolChecked(value.target.checked);
  };
  const onChangeParking = (value: any) => {
    setInputHasParkingChecked(value.target.checked);
  };

  useEffect(() => {
    actions.getProperties(dispatch);
    setPropertiesFiltered(properties);
  }, [dispatch]);

  useEffect(() => {
    setPropertiesFiltered(properties);
  }, [properties]);

  useEffect(() => {
    setPropertiesFiltered(bigFilter());
  }, [
    inputMinPriceValue,
    inputMaxPriceValue,
    inputMinBathrooms,
    inputMinBedrooms,
    inputMinSqFt,
    inputZipcodeValue,
    inputStateValue,
    inputHasYardChecked,
    inputHasACChecked,
    inputHasPoolChecked,
    inputHasParkingChecked,
    inputSortBy,
  ]);

  console.log('home', propertiesFiltered);
  console.log('home', properties)

  return (
    <Spin spinning={isPropertiesLoading} delay={500} size="large">
      <Drawer
        placement="left"
        size={"default"}
        onClose={closeDrawer}
        open={isDrawerOpen}
      >
        <Typography.Title level={5}>Sort By</Typography.Title>
        <Select
          value={inputSortBy}
          style={{ width: "100%" }}
          onChange={handleChangeSortBy}
          defaultValue={"Select"}
          options={[
            { value: "Select", label: "Select" },
            { value: "minPrice", label: "Sort By Lowest Price" },
            { value: "maxPrice", label: "Sort By Highest Price" },
            { value: "minSqFt", label: "Sort By Lowest Sq Ft." },
            { value: "maxSqFt", label: "Sort By Highest Sq Ft." },
          ]}
        />

        <Typography.Title level={5}>Filter By</Typography.Title>
        <Collapse
          expandIconPosition={"end"}
          defaultActiveKey={["1", "2", "3", "4", "5"]}
        >
          <Panel style={{ fontWeight: 700 }} header="Price Range" key="1">
            <Typography.Title
              level={5}
              style={{ marginTop: 0 }}
              ellipsis={{ tooltip: true }}
            >
              Min Price
            </Typography.Title>
            <Slider
              step={50000}
              min={0}
              max={10000000}
              onChange={onChangeMinPrice}
              value={
                typeof inputMinPriceValue === "number" ? inputMinPriceValue : 0
              }
            />
            <InputNumber
              min={0}
              max={10000000}
              style={{ width: "100%" }}
              placeholder="input min price"
              value={inputMinPriceValue}
              onChange={onChangeMinPrice}
            />
            <Typography.Title
              level={5}
              style={{ marginTop: 5 }}
              ellipsis={{ tooltip: true }}
            >
              Max Price
            </Typography.Title>
            <Slider
              step={50000}
              min={0}
              max={10000000}
              onChange={onChangeMaxPrice}
              value={
                typeof inputMaxPriceValue === "number" ? inputMaxPriceValue : 0
              }
            />
            <InputNumber
              min={0}
              max={10000000}
              style={{ width: "100%" }}
              placeholder="input max price"
              value={inputMaxPriceValue}
              onChange={onChangeMaxPrice}
            />
          </Panel>
          <Panel style={{ fontWeight: 700 }} header="Location" key="2">
            <Typography.Title
              level={5}
              style={{ marginTop: 0 }}
              ellipsis={{ tooltip: true }}
            >
              Zip Code
            </Typography.Title>
            <InputNumber
              min={0}
              max={99999}
              value={inputZipcodeValue}
              style={{ width: "100%" }}
              placeholder="Input a Zipcode"
              onChange={onChangeZipcodeValidation}
            />
            <Typography.Title
              level={5}
              style={{ marginTop: 5 }}
              ellipsis={{ tooltip: true }}
            >
              State
            </Typography.Title>
            <Select
              style={{ width: "100%" }}
              value={inputStateValue}
              onChange={onChangeState}
              defaultValue={"Select"}
              options={States}
            />
          </Panel>

          <Panel
            style={{ fontWeight: 700 }}
            header="Bedrooms & Bathrooms"
            key="3"
          >
            <Typography.Title
              level={5}
              style={{ marginTop: 0 }}
              ellipsis={{ tooltip: true }}
            >
              Min Bedrooms
            </Typography.Title>
            <Slider
              step={1}
              min={0}
              max={7}
              onChange={onChangeMinBedrooms}
              value={
                typeof inputMinBedrooms === "number" ? inputMinBedrooms : 0
              }
            />
            <InputNumber
              min={0}
              max={7}
              style={{ width: "100%" }}
              placeholder="input min bedrooms"
              value={inputMinBedrooms}
              onChange={onChangeMinBedrooms}
            />
            <Typography.Title
              level={5}
              style={{ marginTop: 0 }}
              ellipsis={{ tooltip: true }}
            >
              Min Bathrooms
            </Typography.Title>
            <Slider
              step={1}
              min={0}
              max={7}
              onChange={onChangeMinBathrooms}
              value={
                typeof inputMinBathrooms === "number" ? inputMinBathrooms : 0
              }
            />
            <InputNumber
              min={0}
              max={7}
              style={{ width: "100%" }}
              placeholder="input min bathrooms"
              value={inputMinBathrooms}
              onChange={onChangeMinBathrooms}
            />
          </Panel>

          <Panel style={{ fontWeight: 700 }} header="Amenities" key="4">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Checkbox checked={inputHasYardChecked} onChange={onChangeYard}>
                Yard
              </Checkbox>
              <Checkbox
                checked={inputHasACChecked}
                style={{ marginLeft: 0 }}
                onChange={onChangeAC}
              >
                AC
              </Checkbox>
              <Checkbox
                checked={inputHasPoolChecked}
                style={{ marginLeft: 0 }}
                onChange={onChangePool}
              >
                Pool
              </Checkbox>
              <Checkbox
                checked={inputHasParkingChecked}
                style={{ marginLeft: 0 }}
                onChange={onChangeParking}
              >
                Parking
              </Checkbox>
            </div>
          </Panel>

          <Panel style={{ fontWeight: 700 }} header="Sq. Footage" key="5">
            <Typography.Title
              level={5}
              style={{ marginTop: 0 }}
              ellipsis={{ tooltip: true }}
            >
              Min Sq Ft.
            </Typography.Title>
            <InputNumber
              min={0}
              style={{ width: "100%" }}
              placeholder="input min sq ft."
              value={inputMinSqFt}
              onChange={onChangeMinSqFt}
            />
          </Panel>
        </Collapse>
      </Drawer>

      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <Typography.Title
            level={4}
            ellipsis={{ tooltip: true }}
            style={{ padding: "0px 16px" }}
          >
            Properties for you
            <Space style={{ marginLeft: "15px" }}>
              <Button icon={<FilterFilled />} onClick={openDrawer}>Filter</Button>
            </Space>
          </Typography.Title>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <Space size={[4, 12]} wrap style={{ padding: "0px 16px" }}>
            {inputSortBy && (
              <Tag closable onClose={() => handleChangeSortBy("Select")}>
                Sort By: {inputSortBy}
              </Tag>
            )}
            {Boolean(inputMinPriceValue) && (
              <Tag
                closable
                onClose={() => {
                  setInputMinPriceValue(0);
                  setInputMaxPriceValue(MAX_PRICE_VALUE);
                }}
              >
                Price Range: {inputMinPriceValue} to {inputMaxPriceValue}
              </Tag>
            )}
            {inputZipcodeValue && (
              <Tag closable onClose={() => setInputZipcodeValue(undefined)}>
                Zip Code: {inputZipcodeValue}
              </Tag>
            )}
            {inputStateValue && (
              <Tag closable onClose={() => setInputStateValue(undefined)}>
                State: {inputStateValue}
              </Tag>
            )}
            {Boolean(inputMinBedrooms) && (
              <Tag closable onClose={() => setInputMinBedrooms(0)}>
                Min Bedrooms: {inputMinBedrooms}
              </Tag>
            )}
            {Boolean(inputMinBathrooms) && (
              <Tag closable onClose={() => setInputMinBathrooms(0)}>
                Min Bathrooms: {inputMinBathrooms}
              </Tag>
            )}
            {inputHasYardChecked && (
              <Tag closable onClose={() => setInputHasYardChecked(false)}>
                Yard
              </Tag>
            )}
            {inputHasACChecked && (
              <Tag closable onClose={() => setInputHasAChecked(false)}>
                AC
              </Tag>
            )}
            {inputHasPoolChecked && (
              <Tag closable onClose={() => setInputHasPoolChecked(false)}>
                Pool
              </Tag>
            )}
            {inputHasParkingChecked && (
              <Tag closable onClose={() => setInputHasParkingChecked(false)}>
                Parking
              </Tag>
            )}
            {Boolean(inputMinSqFt) && (
              <Tag closable onClose={() => setInputMinSqFt(0)}>
                Sq. Footage: {inputMinSqFt}
              </Tag>
            )}
          </Space>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Row wrap gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={1}></Col>
        {propertiesFiltered && (
          <Col span={22}>
            {/* <NewsletterContact /> */}
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              {propertiesFiltered &&
                propertiesFiltered.map(
                  (property: any, key: any) =>
                    property.fields.ListingPrice && (
                      <Col key={key}>
                        <Link to={`/${property.id}`}>
                          <ListingCard property={property} />
                        </Link>
                      </Col>
                    )
                )}
            </Row>
          </Col>
        )}
        <Col span={1}></Col>
      </Row>
    </Spin>
  );
}

export default Home;
